/* import __COLOCATED_TEMPLATE__ from './deprecation-confirm-body.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Args: {
    confirmContext: {
      salesAgentRoute: string;
    };
  };
}

export default class DeprecationConfirmBody extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare intercomConfirmService: any;

  @action
  navigateToSalesAgent(event: Event): void {
    event.preventDefault();
    let route = this.args.confirmContext.salesAgentRoute;
    // Navigate first, then dismiss the modal
    this.router.transitionTo(route);
    this.intercomConfirmService.reject?.();
    this.intercomConfirmService.closeConfirm();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TaskBots::QualifyLeads::DeprecationConfirmBody': typeof DeprecationConfirmBody;
  }
}
